export default __webpack_public_path__ + "static/media/logoCheckpro2.f37d03ee.png";